var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-label"},[_c('h4',{attrs:{"title":_vm.text}},[_c('u',[_vm._v(" "+_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }